<template>
    <Carousel ref="carouselRef" :mouse-drag="false" :items-to-show="3" :breakpoints="breakpoints" :transition="800">
        <template #default>
            <slot />
        </template>

        <template #addons="{ currentSlide, slidesCount, goToSlide }">
            <div v-if="showControls" class="mt-4 flex justify-center items-center gap-4">
                <button
                    class="group w-10 h-10 rounded-full border-2 border-[#BA90C6] hover:bg-[#BA90C6] [@media(max-width:1023px)]:!bg-[#BA90C6] flex items-center justify-center"
                    @click="prevSlide"
>
                    <font-awesome-icon icon="arrow-left" class="w-5 h-5 text-[#BA90C6] group-hover:text-white [@media(max-width:1023px)]:!text-white" />
                </button>
                <customSliderPagination
:current-slide="currentSlide" :slides-count="slidesCount"
                    @go-to-slide="goToSlide"
/>
                <button
                    class="group w-10 h-10 rounded-full border-2 border-[#BA90C6] hover:bg-[#BA90C6] [@media(max-width:1023px)]:!bg-[#BA90C6] flex items-center justify-center"
                    @click="nextSlide"
>
                    <font-awesome-icon icon="arrow-right" class="w-5 h-5 text-[#BA90C6] group-hover:text-white [@media(max-width:1023px)]:!text-white" />
                </button>
            </div>
        </template>
    </Carousel>
</template>

<script>
import { Carousel } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import customSliderPagination from './customSliderPagination.vue';

export default {
    components: { Carousel, customSliderPagination },
    props: ['length'],

    data() {
        return {
            windowWidth: window.innerWidth,
            observer: null,
            breakpoints: {
                1440: { itemsToShow: 3, wrapAround: false, snapAlign: 'start' },
                1366: { itemsToShow: 2, wrapAround: false, snapAlign: 'start' },
                1024: { itemsToShow: 1, wrapAround: false, snapAlign: 'start' },
                600: { itemsToShow: 1, wrapAround: false, snapAlign: 'start' },
                300: { itemsToShow: 1, wrapAround: false, snapAlign: 'start' }
            }
        };
    },

    computed: {
        isMobileOrTablet() {
            return this.windowWidth <= 1366;
        },

        showControls() {
            if (this.windowWidth > 1439) {
                return this.length > 3;
            } else if (this.windowWidth > 1024 && this.windowWidth <= 1439) {
                return this.length > 2;
            } else {
                return this.length > 1;
            }
        }
    },

    mounted() {
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);

        const wrapper = this.$el.querySelector('.carousel__track'); // Adjust based on DOM structure
        if (wrapper) {
            this.observer = new ResizeObserver((entries) => {
                entries.forEach((entry) => {
                    console.log('Carousel resized:', entry.contentRect.width);
                    if (this.$refs.carouselRef?.updateSlideWidth) {
                        this.$refs.carouselRef.updateSlideWidth();
                    }
                });
            });
            this.observer.observe(wrapper);
        }
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.observer) this.observer.disconnect();
    },

    methods: {
        prevSlide() {
            this.$refs.carouselRef?.prev();
        },
        nextSlide() {
            this.$refs.carouselRef?.next();
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    }
};
</script>